<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="货物名称/编码">
              <a-input v-model.trim="queryParam.materielNameAndCode" placeholder="请输入" />
            </a-form-item>
          </a-col>
        

          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
    </div>

    <s-table v-if="priceLinkBusiness =='1'"
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
         <a-divider type="vertical" />
        <a @click="handlePriceApply(record)">调价申请</a>
        <a-divider type="vertical" />
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>

    <s-table v-if="priceLinkBusiness !='1'"
             ref="table"
             size="default"
             :bordered="config.globlaBordered"
             :rowKey="(record) => record.id"
             :columns="columns2"
             :data="loadData"
             :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>

    <a-modal
      title="操作"
      style="top: 100px;"
      :width="640"
      :confirmLoading="showLoading"
      v-model="visible"
      @ok="handleOk"
      destroyOnClose
    >
      <a-form :form="form">
      <a-form-item label="货物名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
        <a-select placeholder="请选择货物"
                  v-model="mdl.materielId"
                  v-decorator="['materielId',
            { initialValue: mdl.materielId, rules: [{ required: true, message: '请选择物料名称'}]}]"
        >
          <a-select-option
            v-for="(item, index) in materielSelect"
            :key="index"
            :value="item.id"
          >{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>

        <a-form-item label="等级" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select v-model="mdl.customerLevel"  placeholder="请选择"  v-decorator="['customerLevel',
          { initialValue: mdl.customerLevel, rules: [{ required: true, message: '请选择客户等级'}]}]"
          >>
            <a-select-option v-for="(item, index) in levelSelect" :key="index" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

      

      </a-form>
    </a-modal>


     <a-modal
      title="操作"
      style="top: 100px;"
      :width="640"
      :confirmLoading="showLoading"
      v-model="editvisible"
      @ok="handleOkedit"
      destroyOnClose
    >
      <a-form :form="form">

       <a-form-item label="货物名称"  :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="货物名称" v-model="mdl.materielId" v-bind:disabled="true"/>
        </a-form-item>

        <a-form-item label="等级" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select v-model="mdl.customerLevel"  placeholder="请选择"  v-decorator="['customerLevel',
          { initialValue: mdl.customerLevel, rules: [{ required: true, message: '请选择客户等级'}]}]"
          >>
            <a-select-option v-for="(item, index) in levelSelect" :key="index" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

      </a-form>
    </a-modal>


       <a-modal
      title="调价申请"
      style="top: 100px;"
      :width="640"
      :confirmLoading="showLoading"
      v-model="tvisible"
      @ok="thandleOk"
      destroyOnClose
    >
      <a-form :form="form">

       <a-form-item label="货物名称"  :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="货物名称" v-model="mdl.materielId" v-bind:disabled="true" />
        </a-form-item>

  

     <a-form-item label="等级" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select v-model="mdl.customerLevel"  v-bind:disabled="true" placeholder="请选择"  v-decorator="['customerLevel',
          { initialValue: mdl.customerLevel}]"
          >>
            <a-select-option v-for="(item, index) in levelSelect" :key="index" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

      <a-form-item
        label="调整单价(元/吨)"
        validateStatus="success"
        :label-col=" { span: 6 }"
        :wrapper-col=" { span: 12 }"
      >
        <a-input-number
          style="width: 300px"
          placeholder=""
          v-model="mdl.price"
          type="number"
          :min="-5000"
          v-decorator="['price', {rules: [{ required: true, message: '请输入数字类型'}]}]"
        />
      </a-form-item>

      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
  import { STable } from '@/components'
  import {
    businessTypeList,
    getMaterielPricePage,
    materielPriceDelete,
    materielPriceSave,
    materielPriceSavetiaojia,
    materielList,
    corpBusinessList,
    priceLinkBusiness
  } from '@/api/basic'
  import moment from 'moment'
  import { getBizTextByValue } from '@/utils/util'
  import { formatDate } from '../../utils/date.js'
  import Bus from '@/layouts/bus'
  import config from '@/config/defaultSettings'

  export default {
    name: 'MaterielPriceList',
    components: {
      STable
    },
    data() {
      return {
        priceLinkBusiness: '',
        pageSizeOptionsList:['10'],
        description:
          '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
        visible: false,
        tvisible: false,
        editvisible: false,
        // form: null,
        form: this.$form.createForm(this),
        mdl: {},
        disabled: true,

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},

        loading: false,
        showLoading: false,
        // 表头
        columns: [
          {
            title: '物料名称',
            dataIndex: 'materielName',
            width: '120px'
          },
          {
            title: '物料编码',
            dataIndex: 'materielCode',
            width: '120px'
          },
          {
            title: '客户等级',
            dataIndex: 'customerLevel',
            width: '120px',
             customRender:text =>{
              if(text === '1'){
                return 'A'
              }
              if(text === '2'){
                return 'B'
              }
              if(text === '3'){
                return 'C'
              }
              if(text === '4'){
                return 'D'
              }
            }
          },
         
          {
            title: '价格(元/吨)',
            dataIndex: 'price',
            width: '120px',
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '120px',
            scopedSlots: { customRender: 'action' }
          }
        ],

        // 表头
        columns2: [
          {
            title: '物料名称',
            dataIndex: 'materielName',
            width: '120px'
          },
          {
            title: '物料编码',
            dataIndex: 'materielCode',
            width: '120px'
          },
          {
            title: '价格(元/吨)',
            dataIndex: 'price',
            width: '120px',
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '120px',
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return getMaterielPricePage(Object.assign(parameter, this.queryParam)).then(res => {
            return res.data
          })
        },

        selectedRowKeys: [],
        selectedRows: [],

        // 业务类型
        businessSelect: null,
        materielSelect: null,
        levelSelect:null,

      }
    },
    created() {
      this.tableOption()
      this.loadSelectData()
    },
    methods: {
      moment,
      loadSelectData() {
        // 从后台拉取下拉列表数据
        this.levelSelect = this.$store.getters.codeList.basic_corp_level
        new Promise(resolve => {
          const data = materielList().then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.materielSelect = res
        })
        new Promise(resolve => {
          const data = corpBusinessList().then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.businessSelect = res
        })

        
        new Promise(resolve => {

          const data = priceLinkBusiness().then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.priceLinkBusiness = res.priceLinkBusiness
          this.$forceUpdate()
        })

      },


      tableOption() {
        if (!this.optionAlertShow) {
          this.options = {
            alert: {
              show: false,
              clear: () => {
                this.selectedRowKeys = []
              }
            },
            rowSelection: {
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange
            }
          }
          this.optionAlertShow = true
        } else {
          this.options = {
            alert: false,
            rowSelection: null
          }
          this.optionAlertShow = false
        }
      },
      handleEdit(record) {
        this.mdl = Object.assign({}, record)
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.editvisible = true
        this.disabled = true
      },
       handlePriceApply(record) {
        this.mdl = Object.assign({}, record)
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.tvisible = true
        this.disabled = true
      },
      handleAdd() {
        this.mdl = {}
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        this.visible = true
        this.disabled = false
      },
      handleOkedit() {
      
        
         this.form.validateFields((err, values) => {
          Object.assign(this.mdl, values)
          if (!err) {
            this.showLoading = true
            materielPriceSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.editvisible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(res => {
                this.showLoading = false
              })
          }
        })
       
      },

       handleOk() {
       
        this.form.validateFields((err, values) => {
          Object.assign(this.mdl, values)
          if (!err) {
            this.showLoading = true
            materielPriceSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(res => {
                this.showLoading = false
              })
          }
        })
      },

      thandleOk() {
          var error='调价范围不能超过20(元/吨)'
        let value=this.mdl.price
        
        let realVal = ''
        if (!isNaN(value) && value!== '') {
          // 截取当前数据到小数点后两位
          realVal = parseFloat(value).toFixed(2)
        } else {
          realVal = '--'
        }
       // if(realVal >20||realVal<-20){
         // this.$message.error(error)
         // return
        //}
        this.form.validateFields((err, values) => {
          Object.assign(this.mdl, values)
          if (!err) {
            this.showLoading = true
            materielPriceSavetiaojia(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.tvisible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(res => {
                this.showLoading = false
              })
          }
        })
      },
      handleDel(record) {
        var nthis = this
        this.$confirm({
          title: '提示',
          content: '确定要删除吗?',
          onOk() {
            nthis.confirmLoading = true
            return materielPriceDelete(Object.assign(record, nthis.queryParam))
              .then(res => {
                if (res.code === '0') {
                  nthis.$refs.table.refresh()
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                nthis.confirmLoading = false
              })
          },
          onCancel() {}
        })
      },

      onChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
    },
    watch: {
    }
  }
</script>

<style scoped>
  /deep/ .ant-form-item {
    margin-bottom: 10px;
  }
</style>